import React from 'react';
import './TemplatePicker.css';

/**
 * Template selection grid for new session creation.
 * Shows available session templates with icons and descriptions.
 */
function TemplatePicker({ templates, onSelect, isFirstSession }) {
  if (!templates || templates.length === 0) {
    return (
      <div className="template-picker">
        <div className="template-picker__loading">Loading templates...</div>
      </div>
    );
  }

  return (
    <div className="template-picker">
      <h2 className="template-picker__title">What would you like to explore?</h2>

      {isFirstSession && (
        <div className="template-picker__hint">
          First session? "Open Exploration" is a great place to start -
          we'll discover what matters as we go.
        </div>
      )}

      <div className="template-picker__grid">
        {templates.map(template => (
          <button
            key={template.key}
            className="template-card"
            onClick={() => onSelect(template.key)}
          >
            <span className="template-card__icon">{template.icon}</span>
            <span className="template-card__name">{template.name}</span>
            <span className="template-card__desc">{template.short_description}</span>
          </button>
        ))}
      </div>
    </div>
  );
}

export default TemplatePicker;
